import withRouter from "hoc/withRouter";
import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import baggageTariffsService from "services/admin/baggageTariffsService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const BaggageTariffList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const {
    data: tariffsResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["baggage-tariffs", { orgID }],
    queryFn: async () => {
      const response: any = await baggageTariffsService.getAll();
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить тариф?")) return;
    await baggageTariffsService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    const rows: any[] = (tariffsResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>Тарифы отсутствуют. Чтобы добавить тариф, нажмите на кнопку "Добавить" сверху</div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Название</TableCell>
            <TableCell>Контрагент</TableCell>
            <TableCell>Месяц действия</TableCell>
            <TableCell>Базовая ставка/10кг</TableCell>
            <TableCell>Объяв. ценность</TableCell>
            <TableCell>Накладная</TableCell>
            <TableCell>Валюта</TableCell>
            <TableCell>Активен</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.name}</TableCell>
              <TableCell>{c.counterparty?.name || "Публичный"}</TableCell>
              <TableCell>{c.effectiveMonth ? String(c.effectiveMonth).slice(0, 7) : "—"}</TableCell>
              <TableCell>{Number(c.ratePer10Kg)}</TableCell>
              <TableCell>{Number(c.declaredValueFee)}</TableCell>
              <TableCell>{Number(c.waybillFee)}</TableCell>
              <TableCell>{c.currency}</TableCell>
              <TableCell>{c.isActive ? "Да" : "Нет"}</TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/baggages/baggage-tariffs/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <ListPage pageTitle="Тарифы багажа" pathToAdd={`/admin/baggages/baggage-tariffs/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(BaggageTariffList);
